const state = () => ({
    products: [],
    sauces: [],
    attributes: [],
    groups: [],
    filters: [],
    selected_filters: [],
    sauces_modifiers: [],
    pizza_category_id: 5888,
    selectedProductOffer: {},
    selectedProductLargeCard: null,
    stop_list: [],
    productShare: {title: "", description: ""},
    productShares: [],
    isOpenShareModal: false,
    combos: []
})

// getters
const getters = {
    getProducts: (state) => {
        return state.products;
    },
    getProductList: (state) => {
        const groupProducts = state.products;
        let productList = [];
        for(let group_id in groupProducts){
            const products = groupProducts[group_id];
            productList = productList.concat(products);
        }
        return productList;
    },
    getProduct: (state) => (id, category_id) => {
        const products = state.products;
        return products[category_id].find(product => product.id === id);
    },
    getSauces: (state) => {
        return state.sauces;
    },
    getAttributes: (state) => {
        return state.attributes;
    },
    getGroups: (state) => {
        return state.groups;
    },
    getFilters: (state) => {
        return state.filters;
    },
    getSelectedFilters: (state) => {
        return state.selected_filters;
    },
    getSaucesModifiers: (state) => {
        return state.sauces_modifiers;
    },
    getSelectedOffer: (state) => {
        return state.selectedProductOffer;
    },
    getSelectedProductLargeCard: (state) => {
        return state.selectedProductLargeCard;
    },
    getStopList: (state) => {
        return state.stop_list;
    },
    getProductShare: (state) => {
        return state.productShare;
    },
    getProductShares: (state) => {
        return state.productShares;
    },
    isOpenShareModal: (state) => {
        return state.isOpenShareModal;
    },
    getCombos: (state) => {
        return state.combos;
    }
}

// actions
const actions = {
    setCatalogData({commit}, {catalog}) {
        commit('setCatalog', catalog);
    },

    setVote({commit}, {productVote}){
        commit('setProductVote', productVote);
    },

    setSelectFilter({commit}, {filter_id}){
        commit('setSelectFilter', filter_id);
    }
}

// mutations
const mutations = {
    setCatalog(state, {products, sauces, sauce_modifiers, groups, votes, filters, stop_list, attributes, combos}) {
        state.products = products;
        state.sauces = sauces;
        state.attributes = attributes;
        state.groups = groups;
        state.sauces_modifiers = sauce_modifiers;
        state.votes = votes;
        state.filters = filters;
        state.stop_list = stop_list;
        state.combos = combos;
    },

    setProductVote(state, {product_id, group_id, votes},) {
        const Product = state.products[group_id].find(product => product.id === product_id);
        Product.votes = votes;
    },

    setSelectFilter(state, filter_id){
        const filters = state.filters;
        let pizzaProducts = state.products[state.pizza_category_id];

        const selectedFilters = [];
        for(let filter of filters){
            if(filter.id === filter_id) {
                filter.selected = !filter.selected;
            }
            if(filter.selected){
                selectedFilters.push(filter);
            }
        }
        state.selected_filters = selectedFilters;

        for(let filter of selectedFilters){
            for (let pizza of pizzaProducts) {
                if(selectedFilters.length === 1){
                    pizza.visible = false;
                }
                if(pizza.tags.length) {
                    if (pizza.tags.indexOf(filter.id) >= 0) {
                        pizza.visible = true;
                    }
                }
            }
        }

        if(selectedFilters.length === 0){
            pizzaProducts.find(item => {item.visible = true});
        }
    },

    clearSelectedFilter(state){
        state.selected_filters = [];
        let pizzaProducts = state.products[state.pizza_category_id];
        pizzaProducts.find(item => {item.visible = true});

        const filters = state.filters;
        filters.find(item => {item.selected = false});
    },

    setSelectedProductLargeCard: (state, entity) => {
        state.selectedProductLargeCard = entity;
    },

    setSelectedOffer: (state, offer) => {
        state.selectedProductOffer = offer;
    },

    setIsOpenShareModal: (state, value) => {
        state.isOpenShareModal = value;
    },

    setProductShare: (state, value) => {
        state.productShare = value;
    },

    setProductShares: (state, value) => {
        state.productShares = value;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
